import { Poll as PollBase } from '@shared/Polls/Poll';

const PollCard = ({ options: { data, options, isMatchEvent } }) => (
  <PollBase options={options} data={data} isMatchEvent={isMatchEvent} />
);

export default PollCard;
